import { Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    borderRadius: 0,
    width: "100%",
    margin: "auto",
    boxShadow: "none",
    fontSize: "16px",
    marginTop: "20px",
    "@media (max-width: 490px)": {
      width: "90vw",
    },
  },

  tableCell: {
    border: "0.5px solid #CED4D9",
    fontSize: "16px",
    lineHeight: "23px",
    textAlign: "left",
  },

  tableCellBold: {
    fontWeight: "bold",
  },

  headerRow: {
    background: theme.highlightGradientBg,
    fontSize: 16,
  },
  headerCell: {
    fontWeight: 700,
    fontSize: "16px",
    color: "white",
    fontFamily: theme.typography.fontFamily,
    lineHeight: "23px",
  },
}));

export const FahrradVvsAutoRechnerTable = () => {
  const classes = useStyles();
  const { t, lang } = useTranslation("fahrradVvsAutoRechner");
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table style={{ borderCollapse: "collapse" }} size="small" aria-label="customized table">
        <TableHead>
          <TableRow className={classes.headerRow}>
            <TableCell rowSpan={2} className={`${classes.tableCell} ${classes.headerCell}`}>
              {t("tableHeader1")}
            </TableCell>
            <TableCell colSpan={2} className={`${classes.tableCell} ${classes.headerCell}`}>
              {t("tableHeader2")}
            </TableCell>
            <TableCell colSpan={2} className={`${classes.tableCell} ${classes.headerCell}`}>
              {t("tableHeader3")}
            </TableCell>
          </TableRow>
          <TableRow className={classes.headerRow}>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>{t("tableHeader4")}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>{t("tableHeader5")}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>{t("tableHeader4")}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>{t("tableHeader5")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow1")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`${(0.004).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow2")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.003).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow3")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.055).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow4")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.076).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow5")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.004).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.086).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow6")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.002).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow7")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.027).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.027).toLocaleString(lang)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow8")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>?</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>?</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow9")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.006).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow10")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`<${(0.001).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.007).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow11")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.052).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.267).toLocaleString(lang)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow12")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.291).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.093).toLocaleString(lang)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow13")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.002).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.021).toLocaleString(lang)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow14")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`-${(0.321).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`-${(0.223).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow15")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.011).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{`-${(0.534).toLocaleString(lang)}`}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow16")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.001).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>?</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.003).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>?</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={`${classes.tableCell}`}>{t("tableRow17")}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>{(0.11).toLocaleString(lang)}</TableCell>
            <TableCell className={`${classes.tableCell}`}>0</TableCell>
            <TableCell className={`${classes.tableCell}`}>?</TableCell>
          </TableRow>

          <TableRow style={{ fontWeight: "bold" }}>
            <TableCell className={`${classes.tableCell} ${classes.tableCellBold}`}>{t("tableRow18")}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.tableCellBold}`}>{`-${(0.305).toLocaleString(
              lang
            )}`}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.tableCellBold}`}>{`-${(0.302).toLocaleString(
              lang
            )}`}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.tableCellBold}`}>{`${(0.269).toLocaleString(
              lang
            )}`}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.tableCellBold}`}>{`${(0.408).toLocaleString(
              lang
            )}`}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
